/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LogoInputs */

const en_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const es_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo`)
};

const fr_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const de_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const ja_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロゴ`)
};

const zh_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const ar_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشعار`)
};

const id_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const it_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const ru_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип`)
};

const pt_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo`)
};

const ko_logo = /** @type {(inputs: LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로고`)
};

/**
* | output |
* | --- |
* | "Logo" |
*
* @param {LogoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const logo = /** @type {((inputs?: LogoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LogoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logo(inputs)
	if (locale === "es") return es_logo(inputs)
	if (locale === "fr") return fr_logo(inputs)
	if (locale === "de") return de_logo(inputs)
	if (locale === "ja") return ja_logo(inputs)
	if (locale === "zh") return zh_logo(inputs)
	if (locale === "ar") return ar_logo(inputs)
	if (locale === "id") return id_logo(inputs)
	if (locale === "it") return it_logo(inputs)
	if (locale === "ru") return ru_logo(inputs)
	if (locale === "pt") return pt_logo(inputs)
	return ko_logo(inputs)
});